import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArchive, faBars, faBurn, faColumns, faCopy, faExchangeAlt, faFileArchive, faFileExport, faList, faLock, faPlay, faPlus, faShareAlt, faStream, faTrash, faUserLock, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import { BButton, BButtonGroup, BDropdown, BDropdownDivider, BDropdownItem, BDropdownText, BFormCheckbox, BModal, BSpinner, } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { canMutateHistory } from "@/api";
import { iframeRedirect } from "@/components/plugins/legacyNavigation";
import { useToast } from "@/composables/toast";
import { getAppRoot } from "@/onload/loadConfig";
import { useHistoryStore } from "@/stores/historyStore";
import { useUserStore } from "@/stores/userStore";
import localize from "@/utils/localization";
import { rethrowSimple } from "@/utils/simple-error";
import CopyModal from "@/components/History/Modals/CopyModal.vue";
import SelectorModal from "@/components/History/Modals/SelectorModal.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryNavigation',
    props: {
        histories: null,
        history: null,
        historiesLoading: { type: Boolean, default: false },
        minimal: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        library.add(faArchive, faBars, faBurn, faColumns, faCopy, faExchangeAlt, faFileArchive, faFileExport, faLock, faPlay, faPlus, faShareAlt, faList, faStream, faTrash, faUserLock);
        // modal refs
        const showSwitchModal = ref(false);
        const showDeleteModal = ref(false);
        const showPrivacyModal = ref(false);
        const showCopyModal = ref(false);
        const purgeHistory = ref(false);
        const toast = useToast();
        const userStore = useUserStore();
        const historyStore = useHistoryStore();
        const { isAnonymous } = storeToRefs(userStore);
        const { totalHistoryCount } = storeToRefs(historyStore);
        const canEditHistory = computed(() => {
            return canMutateHistory(props.history);
        });
        const isDeletedNotPurged = computed(() => {
            return props.history.deleted && !props.history.purged;
        });
        const historyState = computed(() => {
            if (props.history.purged) {
                return "purged";
            }
            else if (props.history.deleted) {
                return "deleted";
            }
            else if (props.history.archived) {
                return "archived";
            }
            else {
                return "active";
            }
        });
        function onDelete() {
            if (purgeHistory.value) {
                historyStore.deleteHistory(props.history.id, true);
            }
            else {
                historyStore.deleteHistory(props.history.id, false);
            }
        }
        function userTitle(title) {
            if (isAnonymous.value) {
                return localize("Log in to") + " " + localize(title);
            }
            else {
                return localize(title);
            }
        }
        async function resumePausedJobs() {
            const url = `${getAppRoot()}history/resume_paused_jobs?current=True`;
            try {
                const response = await axios.get(url);
                toast.success(response.data.message);
            }
            catch (e) {
                rethrowSimple(e);
            }
        }
        return { __sfc: true, props, showSwitchModal, showDeleteModal, showPrivacyModal, showCopyModal, purgeHistory, toast, userStore, historyStore, isAnonymous, totalHistoryCount, canEditHistory, isDeletedNotPurged, historyState, onDelete, userTitle, resumePausedJobs, faArchive, faBars, faBurn, faColumns, faCopy, faExchangeAlt, faFileArchive, faFileExport, faList, faLock, faPlay, faPlus, faShareAlt, faStream, faTrash, faUserLock, FontAwesomeIcon, BButton, BButtonGroup, BDropdown, BDropdownDivider, BDropdownItem, BDropdownText, BFormCheckbox, BModal, BSpinner, iframeRedirect, localize, CopyModal, SelectorModal };
    }
});
